"use client";

import dynamic from "next/dynamic";

const TabStepperSection = dynamic(
  () =>
    import("./TabStepperSection").then(mod => ({
      default: mod.TabStepperSection,
    })),
  {
    loading: () => <div className="min-h-[480px] w-full animate-pulse bg-gray-50" />,
  }
);

export default TabStepperSection;
